import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseButtonSizeEnum } from '../../base-button/base-button-size.enum';
import { ActiveRemittance } from '../../../../../models/remittances/active-remittance';
import { Routes } from '../../../../../routes/routes';

@Component({
  selector: 'app-employer-contribution-remittance',
  templateUrl: './employer-contribution-remittance.component.html',
  styleUrls: ['../employer-contributions.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployerContributionRemittanceComponent {
  @Input() activeRemittance!: ActiveRemittance;

  public goToRemittance(): void {
    const baseUrl = window.location.origin;
    const hashUrl = Routes.ipProcessRemittance(this.activeRemittance.id);
    const fullUrl = `${baseUrl}/#${hashUrl}`;
    window.open(fullUrl, '_blank', 'noopener,noreferrer');
  }

  protected readonly BaseButtonSizeEnum = BaseButtonSizeEnum;
}
